import { EventsFlowEventNodeTypes } from '../../models/events-flow-event-node-types';
import { INodeStaticMapItem } from '../i-node-static-map-item';

export const WORKFLOW_EVENTS: INodeStaticMapItem[] = [
  {
    name: 'On Call Detail Record',
    icon: 'call',
    color: 'primary',
    isExpandable: false,
    hasInput: false,
    hasOutput: true,
    type: EventsFlowEventNodeTypes.OnCallDetailRecord,
    description: 'Triggered when a call detail record is received',
  },
  {
    name: 'On Recording Available',
    icon: 'graphic_eq',
    color: 'accent',
    isExpandable: false,
    hasInput: false,
    hasOutput: true,
    type: EventsFlowEventNodeTypes.OnRecordingAvailable,
    description: 'Triggered when a recording is available',
  },
  {
    name: 'On New Call Incoming',
    icon: 'ring_volume',
    color: 'accent',
    isExpandable: false,
    hasInput: false,
    hasOutput: true,
    type: EventsFlowEventNodeTypes.OnNewCallIncoming,
    description: 'Triggered when a new call is incoming',
  },
  {
    name: 'On Connect To Agent',
    icon: 'phone_callback',
    color: 'accent',
    isExpandable: false,
    hasInput: false,
    hasOutput: true,
    type: EventsFlowEventNodeTypes.OnConnectToAgent,
    description: 'Triggered when connected to agent',
  },
];
